// ============================================
// CONFIGURAÇÃO DE MONETIZAÇÃO - QUERO PUBLICAR
// ============================================
// 
// INSTRUÇÕES PARA CONFIGURAR:
//
// 1. ADSTERRA:
//    - Acesse: https://www.adsterra.com/
//    - Crie uma conta de publisher
//    - Vá em "Websites" > Adicione seu site
//    - Após aprovação, vá em "Ad Units" > "Create Ad Unit"
//    - Escolha o formato (Banner, Native, etc.)
//    - Copie o código do script gerado
//    - Cole nos campos SCRIPTS abaixo
//
// 2. AMAZON ASSOCIATES:
//    - Acesse: https://associados.amazon.com.br/
//    - Crie uma conta de afiliado
//    - Após aprovação, seu ID estará no canto superior (ex: queropublicar-20)
//    - Substitua AMAZON_AFFILIATE_TAG abaixo
//
// ============================================

// Adsterra Configuration
export const ADSTERRA_CONFIG = {
  // Ative quando tiver os códigos do Adsterra
  ENABLED: false,
  
  // Cole seus códigos de script do Adsterra aqui
  // Cada formato tem um código diferente gerado no painel
  SCRIPTS: {
    // Banner horizontal (728x90)
    // Exemplo: "atOptions = {'key': 'xxxx', 'format': 'iframe', ...}; ..."
    BANNER_728x90: '',
    
    // Banner retângulo (300x250)
    BANNER_300x250: '',
    
    // Anúncios nativos (in-feed)
    NATIVE: '',
    
    // Popunder (opcional - use com moderação)
    POPUNDER: ''
  }
};

// LEGACY: Google AdSense Configuration (deprecated - use Adsterra)
export const ADSENSE_CONFIG = {
  CLIENT_ID: 'ca-pub-XXXXXXXXXXXXXXXX',
  SLOTS: {
    HEADER_BANNER: 'XXXXXXXXXX',
    SIDEBAR: 'XXXXXXXXXX',
    IN_FEED: 'XXXXXXXXXX',
    FOOTER_BANNER: 'XXXXXXXXXX'
  },
  ENABLED: false // Desativado - usando Adsterra agora
};

// Amazon Associates Configuration
export const AMAZON_CONFIG = {
  // Seu Affiliate Tag da Amazon
  // Formato: seunome-20
  AFFILIATE_TAG: 'queropublic07-20',
  
  // País (para URLs corretas)
  COUNTRY: 'br',
  
  // Base URL da Amazon Brasil
  BASE_URL: 'https://www.amazon.com.br',
  
  // Ativar links de afiliado
  ENABLED: true
};

// Função helper para gerar URL de busca Amazon com affiliate tag
export const getAmazonSearchUrl = (searchTerms) => {
  const encodedTerms = encodeURIComponent(searchTerms + ' livro');
  return `${AMAZON_CONFIG.BASE_URL}/s?k=${encodedTerms}&tag=${AMAZON_CONFIG.AFFILIATE_TAG}`;
};

// Função helper para gerar URL de produto Amazon com affiliate tag
export const getAmazonProductUrl = (asin) => {
  return `${AMAZON_CONFIG.BASE_URL}/dp/${asin}?tag=${AMAZON_CONFIG.AFFILIATE_TAG}`;
};

export default {
  ADSTERRA_CONFIG,
  ADSENSE_CONFIG,
  AMAZON_CONFIG,
  getAmazonSearchUrl,
  getAmazonProductUrl
};
